import React, { useEffect } from "react";
import "./CriticalPatientSupport.css";
import AOS from "aos";
import "aos/dist/aos.css";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";
import criticalImg from "../../Asset/Images/criticlepatientsupport.png";

const CriticalPatientSupport = () => {
  const { t } = useTranslation();

  useEffect(() => {
    AOS.init({
      duration: 1200,
      once: true,
    });
  }, []);

  // Keys for the 8 critical support detail cards
  const criticalPoints = [
    "critical.point1",
    "critical.point2",
    "critical.point3",
    "critical.point4",
    "critical.point5",
    "critical.point6",
    "critical.point7",
    "critical.point8"
  ];

  return (
    <div className="critical_page">
      {/* HERO SECTION */}
      <section className="critical_hero">
        <div className="critical_card_container">
          {/* LEFT CONTENT */}
          <div className="critical_content" data-aos="fade-right">
            <span className="service_tag">{t('critical.service_tag')}</span>
            <h1>
              {t('critical.title_start')} <span>{t('critical.title_end')}</span>
            </h1>
            <p>{t('critical.hero_desc')}</p>
          </div>

          {/* RIGHT IMAGE */}
          <div className="critical_image" data-aos="fade-left">
            <img src={criticalImg} alt={t('critical.title_start') + " " + t('critical.title_end')} />
          </div>
        </div>
      </section>

      {/* DETAILS SECTION */}
      <section className="critical_details">
        <h2 data-aos="fade-up">{t('critical.details_title')}</h2>
        <div className="critical_grid">
          {criticalPoints.map((key, index) => (
            <div className="critical_card" key={index} data-aos="zoom-in">
              {t(key)}
            </div>
          ))}
        </div>
      </section>

      {/* CALL TO ACTION */}
      <section className="critical_cta" data-aos="fade-up">
        <h2>{t('critical.cta_title')}</h2>
        <p>{t('critical.cta_desc')}</p>
        <NavLink to="/Contactus">
          <button className="assisted_cta_btn">
            {t('common.contact_us')}
          </button>
        </NavLink>
      </section>
    </div>
  );
};

export default CriticalPatientSupport;